import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useScreen } from '../../../../hooks'
import { isFormMobileActions } from '../../../../utils/screen'
import { Divider } from '../../../Divider'
import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { Content } from '../../../Modal'
import {
  getUserInvitationFormInitialValues,
  USER_FORM_MOBILE_ACTIONS_MAX_WIDTH,
  UserInvitationFormModal,
} from '../../../User'
import { InhabitantFormActions } from '../InhabitantFormActions'
import { InhabitantFormInvitationActions } from '../InhabitantFormInvitationActions'

import { BuildingField } from './BuildingField'
import { ContractEndField } from './ContractEndField'
import { EmailField } from './EmailField'
import { ExternalIdField } from './ExternalIdField'
import { FirstNameField } from './FirstNameField'
import { FlatField } from './FlatField'
import {
  useInvitationModalHandlers,
  useMessageFieldErrorNotification,
} from './InhabitantFormFields.hooks'
import { LastNameField } from './LastNameField'
import { PhoneField } from './PhoneField'
import { RoleField } from './RoleField'

import * as styles from './InhabitantFormFields.module.css'

function InhabitantFormFields({
  ContentComponent = Content,
  buildingSelectApiParams,
  contentComponentProps: {
    size: contentSize = 'xl',
    ...contentComponentProps
  } = EMPTY_OBJECT,
  notifications,
  submitButtonText,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { dirty, errors, isSubmitting, values } = useFormikContext()

  const { width: screenWidth } = useScreen()

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  useMessageFieldErrorNotification({
    errors,
    onRemoveNotification,
    onSetNotification,
  })

  const {
    handleCloseInvitationModal,
    handleOpenInvitationModal,
    handleSubmitInvitationModal,
    showInvitationModal,
  } = useInvitationModalHandlers()

  function handleCancel() {
    onCancel({
      dirty,
    })
  }

  const invitationFormInitialValues = getUserInvitationFormInitialValues(values)

  const isMobileActions = isFormMobileActions({
    maxWidth: USER_FORM_MOBILE_ACTIONS_MAX_WIDTH,
    screenWidth,
  })

  return (
    <>
      <FormBody
        Actions={InhabitantFormActions}
        actionsProps={{
          ButtonAdd: null,
          ButtonClear: null,
          UploadComponent: null,
          cancelProps: {
            onClick: handleCancel,
          },
          className: styles.actions,
          isMobileActions,
          isSubmitting,
          submitProps: {
            isLoading: isSubmitting,
            title: submitButtonText,
          },
          onOpenInvitationModal: handleOpenInvitationModal,
        }}
      >
        <ContentComponent {...contentComponentProps} size={contentSize}>
          <FormInlineNotifications notifications={notifications} />

          <FormFieldsContainer className={styles.formFields}>
            <BuildingField apiParams={buildingSelectApiParams} />
            <FlatField />

            <Divider />

            <RoleField />
            <ExternalIdField />
            <FirstNameField />
            <LastNameField />
            <EmailField />
            <PhoneField />
            <ContractEndField />
            {isMobileActions ? (
              <InhabitantFormInvitationActions
                isSubmitting={isSubmitting}
                onOpenInvitationModal={handleOpenInvitationModal}
              />
            ) : null}
          </FormFieldsContainer>
        </ContentComponent>
      </FormBody>
      {showInvitationModal ? (
        <UserInvitationFormModal
          initialValues={invitationFormInitialValues}
          onClose={handleCloseInvitationModal}
          onSubmit={handleSubmitInvitationModal}
        />
      ) : null}
    </>
  )
}

export default InhabitantFormFields
